export const flagsIdToNameAndISOMap = {
  '1': {
    name: 'Denmark',
    iso: 'DK'
  },
  '2': {
    name: 'England',
    iso: 'EN'
  },
  '3': {
    name: 'Germany',
    iso: 'DE'
  },
  '4': {
    name: 'Italy',
    iso: 'IT'
  },
  '5': {
    name: 'France',
    iso: 'FR'
  },
  '6': {
    name: 'Sweden',
    iso: 'SE'
  },
  '7': {
    name: 'Norway',
    iso: 'NO'
  },
  '8': {
    name: 'Spain',
    iso: 'ES'
  },
  '9': {
    name: 'Netherlands',
    iso: 'NL'
  },
  '11': {
    name: 'Portugal',
    iso: 'PT'
  },
  '12': {
    name: 'Turkey',
    iso: 'TR'
  },
  '13': {
    name: 'Belgium',
    iso: 'BE'
  },
  '14': {
    name: 'Scotland',
    iso: ' '
  },
  '15': {
    name: 'UnitedStates',
    iso: 'US'
  },
  '16': {
    name: 'Slovenia',
    iso: 'SI'
  },
  '17': {
    name: 'CzechRepublic',
    iso: 'CZ'
  },
  '18': {
    name: 'Serbia',
    iso: 'RS'
  },
  '19': {
    name: 'Romania',
    iso: 'RO'
  },
  '20': {
    name: 'Russia',
    iso: 'RU'
  },
  '21': {
    name: 'Canada',
    iso: 'CA'
  },
  '22': {
    name: 'Finland',
    iso: 'FI'
  },
  '23': {
    name: 'Japan',
    iso: 'JP'
  },
  '24': {
    name: 'Hungary',
    iso: 'HU'
  },
  '25': {
    name: 'SouthAfrica',
    iso: 'ZA'
  },
  '26': {
    name: 'Tunisia',
    iso: 'TN'
  },
  '27': {
    name: 'Nigeria',
    iso: 'NG'
  },
  '28': {
    name: 'Egypt',
    iso: 'EG'
  },
  '29': {
    name: 'Cameroon',
    iso: 'CM'
  },
  '30': {
    name: 'Greece',
    iso: 'GR'
  },
  '30_1': {
    name: 'Greece',
    iso: 'EL'
  },
  '31': {
    name: 'Austria',
    iso: 'AT'
  },
  '33': {
    name: 'Switzerland',
    iso: 'CH'
  },
  '34': {
    name: 'Israel',
    iso: 'IL'
  },
  '35': {
    name: 'Australia',
    iso: 'AU'
  },
  '36': {
    name: 'Luxembourg',
    iso: 'LU'
  },
  '37': {
    name: 'Ireland',
    iso: ' '
  },
  '38': {
    name: 'Croatia',
    iso: 'HR'
  },
  '39': {
    name: 'Ireland',
    iso: 'IE'
  },
  '40': {
    name: 'Poland',
    iso: 'PL'
  },
  '41': {
    name: 'Argentina',
    iso: 'AR'
  },
  '42': {
    name: 'Thailand',
    iso: 'TH'
  },
  '43': {
    name: 'Brazil',
    iso: 'BR'
  },
  '44': {
    name: 'Morocco',
    iso: 'MA'
  },
  '45': {
    name: 'Ukraine',
    iso: 'UA'
  },
  '46': {
    name: 'Malta',
    iso: 'MT'
  },
  '47': {
    name: 'Georgia',
    iso: 'GE'
  },
  '48': {
    name: 'Bulgaria',
    iso: 'BG'
  },
  '49': {
    name: 'Belarus',
    iso: 'BY'
  },
  '50': {
    name: 'Wales',
    iso: ''
  },
  '51': {
    name: 'Cyprus',
    iso: 'CY'
  },
  '52': {
    name: 'Estonia',
    iso: 'EE'
  },
  '53': {
    name: 'Latvia',
    iso: 'LV'
  },
  '54': {
    name: 'Slovakia',
    iso: 'SK'
  },
  '55': {
    name: 'SaudiArabia',
    iso: 'SA'
  },
  '56': {
    name: 'Azerbaijan',
    iso: 'AZ'
  },
  '57': {
    name: 'Moldova',
    iso: 'MD'
  },
  '58': {
    name: 'Lithuania',
    iso: 'LT'
  },
  '59': {
    name: 'FaroeIslands',
    iso: 'FO'
  },
  '60': {
    name: 'RepublicOfMacedonia',
    iso: 'MK'
  },
  '61': {
    name: 'Iceland',
    iso: 'IS'
  },
  '62': {
    name: 'BosniaAndHerzegovina',
    iso: 'BA'
  },
  '63': {
    name: 'Albania',
    iso: 'AL'
  },
  '64': {
    name: 'Armenia',
    iso: 'AM'
  },
  '65': {
    name: 'SanMarino',
    iso: 'SM'
  },
  '66': {
    name: 'Liechtenstein',
    iso: 'LI'
  },
  '67': {
    name: 'Andorra',
    iso: 'AD'
  },
  '68': {
    name: 'Chile',
    iso: 'CL'
  },
  '69': {
    name: 'Colombia',
    iso: 'CO'
  },
  '70': {
    name: 'Uruguay',
    iso: 'UY'
  },
  '71': {
    name: 'Ecuador',
    iso: 'EC'
  },
  '72': {
    name: 'Bolivia',
    iso: 'BO'
  },
  '73': {
    name: 'Paraguay',
    iso: 'PY'
  },
  '74': {
    name: 'Peru',
    iso: 'PE'
  },
  '75': {
    name: 'Venezuela',
    iso: 'VE'
  },
  '76': {
    name: 'Algeria',
    iso: 'DZ'
  },
  '77': {
    name: 'Greenland',
    iso: 'GL'
  },
  '78': {
    name: 'Kwait',
    iso: 'KW'
  },
  '79': {
    name: 'SouthKorea',
    iso: 'KR'
  },
  '80': {
    name: 'Malasya',
    iso: 'MY'
  },
  '81': {
    name: 'Singapore',
    iso: 'SG'
  },
  '82': {
    name: 'Qatar',
    iso: 'QA'
  },
  '83': {
    name: 'Zimbabwe',
    iso: 'ZW'
  },
  '84': {
    name: 'NewZealand',
    iso: 'NZ'
  },
  '85': {
    name: 'Fiji',
    iso: 'FJ'
  },
  '86': {
    name: 'Taiwan',
    iso: 'TW'
  },
  '87': {
    name: 'Myanmar',
    iso: 'MM'
  },
  '88': {
    name: 'Libya',
    iso: 'LY'
  },
  '89': {
    name: 'Togo',
    iso: 'TG'
  },
  '90': {
    name: 'Zambia',
    iso: 'ZM'
  },
  '91': {
    name: 'Sudan',
    iso: 'SD'
  },
  '92': {
    name: 'Ghana',
    iso: 'GH'
  },
  '93': {
    name: 'Liberia',
    iso: 'LR'
  },
  '94': {
    name: 'SierraLeone',
    iso: 'SL'
  },
  '95': {
    name: 'Namibia',
    iso: 'NA'
  },
  '96': {
    name: 'Senegal',
    iso: 'SN'
  },
  '97': {
    name: 'RepublicOfTheCongo',
    iso: 'CG'
  },
  '98': {
    name: 'DemocraticRepublicOfCongo',
    iso: 'CD'
  },
  '99': {
    name: 'Malawi',
    iso: 'MW'
  },
  '100': {
    name: 'BurkinaFaso',
    iso: 'BF'
  },
  '101': {
    name: 'IvoryCoast',
    iso: 'CI'
  },
  '102': {
    name: 'Jamaica',
    iso: 'JM'
  },
  '103': {
    name: 'TrinidadAndTobago',
    iso: 'TT'
  },
  '104': {
    name: 'Mexico',
    iso: 'MX'
  },
  '105': {
    name: 'Nicaragua',
    iso: 'NI'
  },
  '106': {
    name: 'ElSalvador',
    iso: 'SV'
  },
  '107': {
    name: 'CostaRica',
    iso: 'CR'
  },
  '108': {
    name: 'Honduras',
    iso: 'HN'
  },
  '109': {
    name: 'Angola',
    iso: 'AO'
  },
  '110': {
    name: 'Madagascar',
    iso: 'MG'
  },
  '111': {
    name: 'NorthKorea',
    iso: 'KP'
  },
  '112': {
    name: 'Iran',
    iso: 'IR'
  },
  '113': {
    name: 'Iraq',
    iso: 'IQ'
  },
  '114': {
    name: 'China',
    iso: 'CN'
  },
  '115': {
    name: 'Mali',
    iso: 'ML'
  },
  '116': {
    name: 'Jordan',
    iso: 'JO'
  },
  '117': {
    name: 'HongKong',
    iso: 'HK'
  },
  '118': {
    name: 'Kazakhstan',
    iso: 'KZ'
  },
  '119': {
    name: 'Uzbekistn',
    iso: 'UZ'
  },
  '120': {
    name: 'Benin',
    iso: 'BJ'
  },
  '121': {
    name: 'India',
    iso: 'IN'
  },
  '122': {
    name: 'Oman',
    iso: 'OM'
  },
  '123': {
    name: 'Laos',
    iso: 'LA'
  },
  '124': {
    name: 'Guatemala',
    iso: 'GT'
  },
  '125': {
    name: 'Cuba',
    iso: 'CU'
  },
  '126': {
    name: 'Martinique',
    iso: 'MQ'
  },
  '127': {
    name: 'Haiti',
    iso: 'HT'
  },
  '128': {
    name: 'Bahamas',
    iso: 'BS'
  },
  '129': {
    name: 'Indonesia',
    iso: 'ID'
  },
  '130': {
    name: 'PuertoRico',
    iso: 'PR'
  },
  '131': {
    name: 'Panama',
    iso: 'PA'
  },
  '132': {
    name: 'Bahrain',
    iso: 'BH'
  },
  '133': {
    name: 'Rwanda',
    iso: 'RW'
  },
  '134': {
    name: 'Guinea',
    iso: 'GN'
  },
  '135': {
    name: 'Kenya',
    iso: 'KE'
  },
  '136': {
    name: 'Yemen',
    iso: 'YE'
  },
  '137': {
    name: 'Barbados',
    iso: 'BB'
  },
  '138': {
    name: 'Kyrgyzstan',
    iso: 'KG'
  },
  '139': {
    name: 'Botswana',
    iso: 'BW'
  },
  '140': {
    name: 'Gabon',
    iso: 'GA'
  },
  '141': {
    name: 'CapeVerde',
    iso: 'CV'
  },
  '142': {
    name: 'Uganda',
    iso: 'UG'
  },
  '143': {
    name: 'Vietnam',
    iso: 'VN'
  },
  '144': {
    name: 'SriLanka',
    iso: 'LK'
  },
  '145': {
    name: 'Palestine',
    iso: ' '
  },
  '146': {
    name: 'Syria',
    iso: 'SY'
  },
  '147': {
    name: 'Tajikistan',
    iso: 'TJ'
  },
  '148': {
    name: 'Lebanon',
    iso: 'LB'
  },
  '149': {
    name: 'Maldives',
    iso: 'MV'
  },
  '150': {
    name: 'Turkmenistan',
    iso: 'TM'
  },
  '151': {
    name: 'Pakistan',
    iso: 'PK'
  },
  '152': {
    name: 'DominicanRepublic',
    iso: 'DO'
  },
  '153': {
    name: 'SaintKittsAndNevis',
    iso: 'KN'
  },
  '154': {
    name: 'StVincentAndTheGrenadines',
    iso: 'VC'
  },
  '155': {
    name: 'Vanuatu',
    iso: 'VU'
  },
  '156': {
    name: 'Vanuatu',
    iso: 'VU'
  },
  '157': {
    name: 'SolomonIslands',
    iso: 'SB'
  },
  '158': {
    name: 'UnitedKingdom',
    iso: 'GD'
  },
  '159': {
    name: 'Tonga',
    iso: 'TO'
  },
  '160': {
    name: 'Philippines',
    iso: 'PH'
  },
  '161': {
    name: 'Mongolia',
    iso: 'MN'
  },
  '162': {
    name: 'Afghanistan',
    iso: 'AF'
  },
  '163': {
    name: 'Lesotho',
    iso: 'LS'
  },
  '164': {
    name: 'Nepal',
    iso: 'NP'
  },
  '165': {
    name: 'Ethiopia',
    iso: 'ET'
  },
  '166': {
    name: 'Mauritius',
    iso: 'MU'
  },
  '167': {
    name: 'Seychelles',
    iso: 'SC'
  },
  '168': {
    name: 'Brunei',
    iso: 'BN'
  },
  '169': {
    name: 'VirginIslands',
    iso: 'VI'
  },
  '170': {
    name: 'Micronesia',
    iso: 'FM'
  },
  '171': {
    name: 'Bermuda',
    iso: 'BM'
  },
  '172': {
    name: 'Nauru',
    iso: 'NR'
  },
  '173': {
    name: 'CentralAfricanRepublic',
    iso: 'CF'
  },
  '174': {
    name: 'Guam',
    iso: 'GU'
  },
  '175': {
    name: 'Netherlands',
    iso: 'AN'
  },
  '176': {
    name: 'Bangladesh',
    iso: 'BD'
  },
  '177': {
    name: 'Bhutan',
    iso: 'BT'
  },
  '178': {
    name: 'Monaco',
    iso: 'MC'
  },
  '179': {
    name: 'AntiguaAndBarbuda',
    iso: 'AG'
  },
  '180': {
    name: 'AmericanSamoa',
    iso: 'AS'
  },
  '181': {
    name: 'Belize',
    iso: 'BZ'
  },
  '182': {
    name: 'Aruba',
    iso: 'AW'
  },
  '183': {
    name: 'Burundi',
    iso: 'BI'
  },
  '184': {
    name: 'CaymanIslands',
    iso: 'KY'
  },
  '185': {
    name: 'Djibouti',
    iso: 'DJ'
  },
  '186': {
    name: 'Dominica',
    iso: 'DM'
  },
  '187': {
    name: 'EquatorialGuinea',
    iso: 'GQ'
  },
  '188': {
    name: 'Eritrea',
    iso: 'ER'
  },
  '189': {
    name: 'CookIslands',
    iso: 'CK'
  },
  '190': {
    name: 'Cambodia',
    iso: 'KH'
  },
  '191': {
    name: 'FrenchGuiana',
    iso: 'GF'
  },
  '192': {
    name: 'Gambia',
    iso: 'GM'
  },
  '193': {
    name: 'StLucia',
    iso: 'LC'
  },
  '194': {
    name: 'Niger',
    iso: 'NE'
  },
  '195': {
    name: 'PapuaNewGuinea',
    iso: 'PG'
  },
  '196': {
    name: 'Chad',
    iso: 'TD'
  },
  '197': {
    name: 'Swaziland',
    iso: 'SZ'
  },
  '198': {
    name: 'Comoros',
    iso: 'KM'
  },
  '199': {
    name: 'Kiribati',
    iso: 'KI'
  },
  '200': {
    name: 'Grenada',
    iso: 'GD'
  },
  '201': {
    name: 'BritishVirginIslands',
    iso: 'VG'
  },
  '202': {
    name: 'Mozambique',
    iso: 'MZ'
  },
  '203': {
    name: 'Guyana',
    iso: 'GY'
  },
  '204': {
    name: 'Mauritania',
    iso: 'MR'
  },
  '205': {
    name: 'Tanzania',
    iso: 'TZ'
  },
  '206': {
    name: 'Somalia',
    iso: 'SO'
  },
  '207': {
    name: 'Suriname',
    iso: 'SR'
  },
  '208': {
    name: 'SaoTomeAndPrince',
    iso: 'ST'
  },
  '209': {
    name: 'EastTimor',
    iso: 'TL'
  },
  '210': {
    name: 'Palau',
    iso: 'PW'
  },
  '211': {
    name: 'Samoa',
    iso: 'WS'
  },
  '212': {
    name: 'EuropeanUnion',
    iso: ' '
  },
  '213': {
    name: 'UnitedKingdom',
    iso: 'IE'
  },
  '215': {
    name: 'Macao',
    iso: 'MO'
  },
  '216': {
    name: 'Guadeloupe',
    iso: 'GP'
  },
  '217': {
    name: 'Montenegro',
    iso: 'ME'
  },
  '220': {
    name: 'EastTimor',
    iso: 'TL'
  },
  '221': {
    name: 'NewCaledonia',
    iso: 'NC'
  },
  '222': {
    name: 'Gibraltar',
    iso: 'GI'
  },
  '223': {
    name: 'GuineaBissau',
    iso: 'GW'
  },
  '224': {
    name: 'MarshallIsland',
    iso: 'MH'
  },
  '225': {
    name: 'Tuvalu',
    iso: 'TV'
  },
  '226': {
    name: 'Jersey',
    iso: 'JE'
  },
  '227': {
    name: 'ChristmasIsland',
    iso: 'CX'
  },
  '228': {
    name: 'Anguilla',
    iso: 'AI'
  },
  '267': {
    name: 'World',
    iso: ''
  },
  '268': {
    name: 'UnitedStates',
    iso: ''
  },
  '285': {
    name: 'UnitedKingdom',
    iso: 'GB'
  },
  '287': {
    name: 'Croatia',
    iso: 'HR'
  },
  '290': {
    name: 'Antarctica',
    iso: 'AQ'
  },
  '291': {
    name: 'BosniaAndHerzegovina',
    iso: 'BA'
  },
  '292': {
    name: 'BouvedIsland',
    iso: 'BV'
  },
  '293': {
    name: 'BritishIndianOceanTerritory',
    iso: 'IO'
  },
  '294': {
    name: 'Brunei',
    iso: 'BN'
  },
  '295': {
    name: 'CentralAfricanRepublic',
    iso: 'CF'
  },
  '296': {
    name: 'CocosIsland',
    iso: 'CC'
  },
  '297': {
    name: 'DemocraticRepublicOfCongo',
    iso: 'CD'
  },
  '298': {
    name: 'IvoryCoast',
    iso: 'CI'
  },
  '299': {
    name: 'DominicanRepublic',
    iso: 'DO'
  },
  '300': {
    name: 'EquatorialGuinea',
    iso: 'GQ'
  },
  '301': {
    name: 'FalklandIslands',
    iso: 'FK'
  },
  '302': {
    name: 'FrenchGuiana',
    iso: 'GF'
  },
  '303': {
    name: 'FrenchPolynesia',
    iso: 'PF'
  },
  '304': {
    name: 'FrenchSouthernTerritories',
    iso: 'TF'
  },
  '305': {
    name: 'Grenada',
    iso: 'GD'
  },
  '306': {
    name: 'HeardMcdonaldIslands',
    iso: 'HM'
  },
  '307': {
    name: 'VaticanCity',
    iso: 'VA'
  },
  '308': {
    name: 'Iran',
    iso: 'IR'
  },
  '309': {
    name: 'NorthKorea',
    iso: 'KP'
  },
  '310': {
    name: 'SouthKorea',
    iso: 'KR'
  },
  '311': {
    name: 'Laos',
    iso: 'LA'
  },
  '312': {
    name: 'Libya',
    iso: 'LY'
  },
  '313': {
    name: 'RepublicOfMacedonia',
    iso: 'MK'
  },
  '314': {
    name: 'Mauritania',
    iso: 'MR'
  },
  '315': {
    name: 'Mayotte',
    iso: 'YT'
  },
  '316': {
    name: 'Micronesia',
    iso: 'FM'
  },
  '318': {
    name: 'Montserrat',
    iso: 'MS'
  },
  '319': {
    name: 'Myanmar',
    iso: 'MM'
  },
  '320': {
    name: 'Niue',
    iso: 'NU'
  },
  '321': {
    name: 'NorfolkIsland',
    iso: 'NF'
  },
  '322': {
    name: 'NorthernMarianasIslands',
    iso: 'MP'
  },
  '323': {
    name: 'Palestine',
    iso: 'PS'
  },
  '324': {
    name: 'PitcairnIslands',
    iso: 'PN'
  },
  '325': {
    name: 'Réunion',
    iso: 'RE'
  },
  '327': {
    name: 'StHelena',
    iso: 'SH'
  },
  '328': {
    name: 'SaintKittsAndNevis',
    iso: 'KN'
  },
  '329': {
    name: 'PierreAndMiquelon',
    iso: 'PM'
  },
  '330': {
    name: 'StVincentAndTheGrenadines',
    iso: 'VC'
  },
  '331': {
    name: 'Serbia',
    iso: 'CS'
  },
  '332': {
    name: 'Georgia',
    iso: 'GS'
  },
  '333': {
    name: 'Suriname',
    iso: 'SR'
  },
  '334': {
    name: 'SvalbardJanMayen',
    iso: 'SJ'
  },
  '335': {
    name: 'Syria',
    iso: 'SY'
  },
  '336': {
    name: 'Taiwan',
    iso: 'TW'
  },
  '337': {
    name: 'Tanzania',
    iso: 'TZ'
  },
  '338': {
    name: 'Tokelau',
    iso: 'TK'
  },
  '339': {
    name: 'TurksAndCaicos',
    iso: 'TC'
  },
  '340': {
    name: 'UnitedArabEmirates',
    iso: 'AE'
  },
  '341': {
    name: 'UnitedStates',
    iso: 'US'
  },
  '342': {
    name: 'UnitedStates',
    iso: 'UM'
  },
  '343': {
    name: 'Vietnam',
    iso: 'VN'
  },
  '344': {
    name: 'BritishVirginIslands',
    iso: 'VG'
  },
  '345': {
    name: 'VirginIslands',
    iso: 'VI'
  },
  '346': {
    name: 'WallisAndFutuna',
    iso: 'WF'
  },
  '348': {
    name: 'Transnistria',
    iso: 'TS'
  },
  '349': {
    name: 'Finland',
    iso: ' '
  },
  '351': {
    name: 'SouthKorea',
    iso: ' '
  },
  '355': {
    name: 'UnitedStates',
    iso: ' '
  },
  '356': {
    name: 'UnitedStates',
    iso: ' '
  },
  '357': {
    name: 'UnitedNations',
    iso: ' '
  },
  '358': {
    name: 'World',
    iso: ' '
  },
  '360': {
    name: 'Mexico',
    iso: 'MX'
  },
  '361': {
    name: 'Argentina',
    iso: 'ARG'
  },
  '362': {
    name: 'Egypt',
    iso: 'EG'
  },
  '363': {
    name: 'UnitedNations',
    iso: ' '
  },
  '366': {
    name: 'Bahrain',
    iso: 'BH'
  },
  '367': {
    name: 'SaudiArabia',
    iso: 'SA'
  },
  '368': {
    name: 'SaudiArabia',
    iso: 'SA'
  },
  '369': {
    name: 'Turkey',
    iso: 'TR'
  },
  '370': {
    name: 'Canada',
    iso: 'CA'
  },
  '371': {
    name: 'UnitedArabEmirates',
    iso: 'AE'
  },
  '372': {
    name: 'HongKong',
    iso: 'HK'
  },
  '373': {
    name: 'Macao',
    iso: 'MO'
  },
  '374': {
    name: 'Iceland',
    iso: 'IS'
  },
  '375': {
    name: 'SouthSudan',
    iso: 'SS'
  },
  '376': {
    name: 'World',
    iso: ''
  },
  '377': {
    name: 'DominicanRepublic',
    iso: 'DO'
  },
  '378': {
    name: 'Colombia',
    iso: 'CO'
  },
  '382': {
    name: 'Romania',
    iso: 'RO'
  },
  '383': {
    name: 'UnitedKingdom',
    iso: ' '
  },
  '384': {
    name: 'Australia',
    iso: 'AU'
  },
  '385': {
    name: 'Armenia',
    iso: 'AM'
  },
  '389': {
    name: 'Turkey',
    iso: 'TR'
  },
  '390': {
    name: 'Lebanon',
    iso: 'LB'
  },
  '391': {
    name: 'Lebanon',
    iso: 'LB'
  },
  '392': {
    name: 'Lebanon',
    iso: 'LB'
  },
  '393': {
    name: 'Morocco',
    iso: 'MA'
  },
  '394': {
    name: 'UnitedNations',
    iso: ' '
  },
  '395': {
    name: 'Slovakia',
    iso: 'SK'
  },
  '396': {
    name: 'Nigeria',
    iso: 'NE'
  },
  '397': {
    name: 'Zimbabwe',
    iso: 'ZW'
  },
  '398': {
    name: 'Georgia',
    iso: 'GE'
  },
  '401': {
    name: 'WesternSahara',
    iso: 'EH'
  },
  '30405': {
    name: 'Argentina',
    iso: 'ARG'
  }
} as const;

export type FlagIdToNameAndISOMap = typeof flagsIdToNameAndISOMap;
